import { LIMPAR_RESERVAS_MARCACAO } from '../types'

export default function limparReservasRemarcacao () {
  return {
    type: LIMPAR_RESERVAS_MARCACAO
  }
}
